import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const idanTrades: SeasonTrades[] = [
  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway:
          "Paul George (Out For Season) and 11th pick in Veterans Draft",
        gotInReturn: "Mike Conley and 3rd pick in Veterans Draft",
      },
      {
        otherTeam: manager.dom,
        sentAway: "Hassan Whiteside and Mike Conley",
        gotInReturn: "Gordon Hayward and Nikola Pekovic",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jabari Parker, Kenneth Faried and Arron Afflalo",
        gotInReturn: "DeAndre Jordan, Tobias Harris and Darren Collison",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Isaiah Canaan",
        gotInReturn: "Monta Ellis",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Al Horford and Jeff Teague",
        gotInReturn: "Marc Gasol and Derrick Rose",
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Kyle Lowry, Ed Davis and Ben McLemore",
        gotInReturn: "Hassan Whiteside",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "DeAndre Jordan",
        gotInReturn: "Kyle Lowry and Robert Covington",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Jimmy Butler",
        gotInReturn: "Al Horford and Jeff Teague",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Tony Snell",
        gotInReturn: "Enes Kanter",
      },
    ],
  },
  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.oded,
        sentAway: "Frank Kaminsky",
        gotInReturn: "Otto Porter Jr",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Marc Gasol and Marcus Smart",
        gotInReturn: "Kyle Korver and Jonas Valanciunas",
      },
      {
        otherTeam: manager.itay,
        sentAway: "Trevor Ariza and Jeff Teague",
        gotInReturn: "Al Horford",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Tobias Harris",
        gotInReturn: "Omri Casspi",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Ricky Rubio",
        gotInReturn: "Mike Conley",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Al Horford",
        gotInReturn: "Marcin Gortat and Kenneth Faried",
      },
      {
        otherTeam: manager.ariel,
        sentAway: "Marcin Gortat and Mike Conley",
        gotInReturn: "Derrick Favors and PJ Tucker",
      },
    ],
  },
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.zeev,
        sentAway: "Clint Capela",
        gotInReturn: "John Wall"
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "John Wall and 8th pick in Veterans Draft",
        gotInReturn: "Klay Thompson and 4th pick in Veterans Draft",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Klay Thompson",
        gotInReturn: "Kyle Lowry"
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Trevor Ariza",
        gotInReturn: "Gordon Hayward",
        amongBestTrades: true
      },
      
      {
        otherTeam: manager.yevgeny,
        sentAway: "Kristaps Porzingis and Danilo Gallinari",
        gotInReturn: "Rudy Gobert and Klay Thompson",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Klay Thompson",
        gotInReturn: "Steven Adams",
      },
      {
        otherTeam: manager.ilya,
        sentAway: "Kyle Lowry and Willy Cauley-Stein",
        gotInReturn: "Goran Dragic and Gorgui Dieng",
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Gordon Hayward",
        gotInReturn: "Caris LeVert",
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Jaylen Brown and Bobby Portis",
        gotInReturn: "Al Horford and Richaun Holmes",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Giannis Antetokounmpo and JJ Redick",
        gotInReturn: "Stephen Curry and Steven Adams",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Lou Williams",
        gotInReturn: "DeAndre Jordan",
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.shiran,
        sentAway: "John Collins",
        gotInReturn: "Paul George",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Donovan Mitchell",
        gotInReturn: "LeBron James",
        amongBestTrades: true,
      },
      {
        otherTeam: manager.shiran,
        sentAway: "Lebron James",
        gotInReturn: "Kawhi Leonard"
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Kawhi Leonard",
        gotInReturn: "Klay Thompson and Mitchell Robinson",
      },
    ],
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Paul George",
        gotInReturn: "Jimmy Butler",
        amongBestTrades: true
      },
      {
        otherTeam: manager.mati,
        sentAway: "Kendrick Nunn",
        gotInReturn: "Lou Williams"
      },
      {
        otherTeam: manager.nissim,
        sentAway: "Lou Williams",
        gotInReturn: "Khris Middleton"
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Khris Middleton and Gordon Hayward",
        gotInReturn: "Brandon Ingram and Reggie Bullock"
      }
      
    ]
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Devonte Graham and 4th round pick",
        gotInReturn: "3rd round pick"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Tyrese Haliburton",
        gotInReturn:  "Bam Adebayo",
        amongBestTrades: true
      }
      
    ]
  },
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.rony,
        sentAway: "Stephen Curry and 1st round pick (#11)",
        gotInReturn: "1st round pick (#2) and Bradley Beal",
        amongWorstTrades: true
      },
        
    ]
},
{
  season: "2022/23",
  allTrades: [
    {
      otherTeam: manager.itay,
      sentAway: "Bradley Beal and 4th round pick",
      gotInReturn: "3rd round pick (#23)",
      amongBestTrades: true
    },
    {
      otherTeam: manager.mati,
      sentAway: "LeBron James, Rudy Gobert, Isaiah Jackson and 3rd round pick",
      gotInReturn: "Keegan Murray, Jamal Murray, Michael Porter Jr and 1st round pick",
      amongBestTrades: true
    },
    {
      otherTeam: manager.mati,
      sentAway: "Anfernee Simons",
      gotInReturn: "Fred VanVleet",
      amongBestTrades: true
    },
  ]
},
{
  season: "2023/24",
  allTrades: [
    {
      otherTeam: manager.nissim,
      sentAway: "Chet Holmgren",
      gotInReturn: "LaMelo Ball",
      amongWorstTrades: true
    },
    {
      otherTeam: manager.mati,
      sentAway: "Jalen Williams and Jakob Poeltl",
      gotInReturn: "Domantas Sabonis and Tari Eason"
    },
    {
      otherTeam: manager.yoni,
      sentAway: "Domantas Sabonis and Anfernee Simons",
      gotInReturn: "Tyrese Maxey and Keldon Johnson",
      amongBestTrades: true
    },
  ]
},
{
  season: "2024/25",
  allTrades: [
    {
        otherTeam: manager.shahar,
        sentAway: "Dereck Lively",
        gotInReturn: "Jabari Smith",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.dom,
        sentAway: "Donovan Mitchell and Gradey Dick", 
        gotInReturn: "Brandon Miller"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Dyson Daniels",
        gotInReturn: "Kawhi Leonard and Matas Buzelis",
        amongBestTrades: true
      },
  ]
}
];
